module.exports = __webpack_public_path__ + "static/media/Spinner_Horse_Race_Game.ac939d72.png";